import { formatOrAnonymize } from "./format-or-anonymize";

export const toLQPercentString = (val: any) => {
  const finalValue = formatOrAnonymize(
    val,
    (val) => {
      const valueNum = Number(val);
      const valueFinal = valueNum === 0 ? '0'
        : valueNum == 100 || valueNum == -100 ? valueNum.toFixed(0)
        : valueNum.toFixed(1)

      return valueFinal
    }
  )

  if (finalValue == '*') {
    return finalValue
  }

  const sign = Number(val) > 0 ? '+' : ''

  return `${sign}${finalValue}%`
}